export default __webpack_public_path__ + "static/media/diners.3af023d2.svg";